// export const defaultActor = Object.freeze({
//   id: '',
//   refId: '',
//   type: 'invalid',
//   project: undefined,
//   user: undefined,
//   answersD: {},
//   answersInputD: {}
// })
import { put } from 'utils/dict'

import { normalizeAnswer } from './answer'

export function normalizeActor({
  id,
  refId,
  type = 'invalid',
  project,
  user,
  answers
}) {
  let answersD = {}
  let answersInputD = {}
  if (answers) {
    // by answer ID
    answersD = answers.reduce((d, a) => put(d, a.id, normalizeAnswer(a)), {})
    // by challengeInput ID
    answersInputD = answers.reduce((d, a) => put(d, a.inputId, a.id), {})
  }
  return Object.freeze({
    id,
    refId,
    type,
    project,
    user,
    answersD,
    answersInputD
  })
}
